import BaseApiService from '@/core/services/baseApi.service';

export default class AuthService extends BaseApiService {
  constructor() {
    super('/auth');
  }

  getToken(username, password) {
    return this.post('/token', {
      username,
      password
    });
  }
}
